import React, {FC} from 'react';

import {InputCurrency} from '@zoefin/design-system';

import {INPUT_THEME} from '../../constants';
import {useFhs, useFhsActor} from '../../store/FhsContext/hooks';
import type {FhsField} from '../../types';

import styles from './styles.module.scss';

interface QuestionCurrencyProps {
  field: FhsField;
  label?: string;
  placeholder?: string;
  hintText?: string;
}

const QuestionCurrency: FC<QuestionCurrencyProps> = ({
  field,
  label,
  placeholder,
  hintText,
}) => {
  const actor = useFhsActor();
  const {formData, errors, touched} = useFhs();

  const raw = formData[field];
  const value = typeof raw === 'string' ? raw : '';
  const error = touched[field] ? errors[field] : undefined;

  return (
    <InputCurrency
      id={`fhs-${String(field)}`}
      name={String(field)}
      label={label}
      className={styles.questionCurrency}
      placeholder={placeholder ?? '$0.00'}
      hintText={hintText}
      theme={{
        ...INPUT_THEME,
        hintMessage: {marginTop: 6},
        errorMessage: {marginTop: 6, position: 'static'},
      }}
      value={value}
      allowDecimal
      maxLength={50}
      hasError={Boolean(error)}
      errorMessage={error}
      onChange={(event) => {
        const {target} = event;

        actor.send({type: 'UPDATE_FIELD', field, value: target.value});
      }}
    />
  );
};

export default QuestionCurrency;
